import React, { Component } from "react";
import { Consume } from "../../Context/Consumer";
import {
  WebConfigDataContext,
  ConstraintsContext,
  TransContext,
  FixturesContext,
  CompositionContext,
  TeamDataContext,
  PlayerListContext,
  PlayerRecommendationContext,
  GamedaysContext,
  LoginContext,
  LiveScoringContext,
  BoosterCardContext,
} from "../../Context";
import config from "../../common/config";
import {
  makeClasses,
  getTrans,
  getTeamDeadlineObj,
  setGameModeOnFixtures,
  showLoader,
  hideLoader,
  makeManageTeamSkeleton,
  checkIsAnyVersionChanged,
  getOverallGamedayPoints,
  getAppliedBooster,
  getBoostersObject,
} from "../../common";
import Swiper from "react-id-swiper";
import { isEmpty } from "lodash";
import { Fragment } from "react";
import moment from "moment";
import "moment/locale/ar";

class FixturesStrip extends Component {
  constructor(props) {
    super(props);
    this.goNext = this.goNext.bind(this);
    this.goPrev = this.goPrev.bind(this);
    this.getTeam = this.getTeam.bind(this);
    this.state = {
      isBeginning: false,
      isEnd: false,
      initialSlideDesktop: 0,
      initialSlideTab: 0,
      initialSlideMobile: 0,
      isSet: false,
      disableBack: false,
      disableForward: false,
    };
    this.swiper = null;
    this.currMatchDay = null;
  }

  getTeamDataOfMD = () => {
    this.props.setLoader(true);
    let selectedMatchDayId = this.props.FixturesData.currMatchDay.Matchday;
    let selectedGDId = this.props.FixturesData.currMatchDay.GamedayId;
    let selectedPhaseId = this.props.FixturesData.currMatchDay.PhaseId;
    let selectedMd = this.props.FixturesData.currMatchDay;
    if (this.props.selectedMdFromUrl) {
      let isPlayed = this.props.fixturesStrip.find((md) => {
        return md.Matchday == this.props.selectedMdFromUrl && md.playedGames;
      });
      if (isPlayed) {
        selectedMatchDayId = this.props.selectedMdFromUrl;
        selectedPhaseId = this.props.FixturesData.data[selectedMatchDayId - 1]
          ? this.props.FixturesData.data[selectedMatchDayId - 1].phId
          : "";
        selectedMd = this.props.FixturesData.data[selectedMatchDayId - 1]
          ? this.props.FixturesData.data[selectedMatchDayId - 1]
          : this.props.FixturesData.currMatchDay;
      }

      this.props.FixturesData.setCurrMatchDay(selectedMd);
    }
  };

  componentWillMount() {
    this.getTeamDataOfMD();
  }

  componentDidUpdate(prevProps, prevState) {
    let self = this;
    if (
      self.props.FixturesData.fixturesStrip.length !==
        prevProps.FixturesData.fixturesStrip.length ||
      JSON.stringify(prevProps.FixturesData?.data) !==
        JSON.stringify(self.props.FixturesData?.data)
    ) {
      self.renderSwiper(self.props.FixturesData.fixturesStrip);
      self.currMatchDay = null;
    }
  }

  swiperButtonSetState = (fixtures) => {
    let self = this;
    let nextMdId = fixtures.Matchday + 1;
    let prevMdId = fixtures.Matchday - 1;
    let forwardFix = this.props.FixturesData.data[nextMdId - 1];
    let backFix = this.props.FixturesData.data[prevMdId - 1];
    if (!isEmpty(forwardFix) && !isEmpty(forwardFix.playedGames)) {
      this.setState({
        disableForward: false,
      });
    } else {
      this.setState({
        disableForward: true,
      });
    }

    if (!isEmpty(backFix) && !isEmpty(backFix.playedGames)) {
      this.setState({
        disableBack: false,
      });
    } else {
      this.setState({
        disableBack: true,
      });
    }
  };

  getTeam = (fixtures, fromScoring) => {
    if (
      (fixtures.playedGames &&
        fixtures.GamedayId != this.props.FixturesData.currMatchDay.GamedayId) ||
      fromScoring
    ) {
      checkIsAnyVersionChanged();
      this.props.setLoader(true);
      this.swiperButtonSetState(fixtures);
      showLoader();
      this.props.Gamedays.setIsTeamLoading(true);
      this.props.Gamedays.setTeamCalled(true);
      this.props.FixturesData.setCurrMatchDay(fixtures);
      //setDefault sort option

      let getFixturesMode = fixtures.playedGames.mds;
      let gameMode = setGameModeOnFixtures(getFixturesMode);
      this.props.FixturesData.setGameMode(gameMode);
      this.props.Gamedays.getSelectedTeam(
        {
          optType: config.optType,
          gamedayId: fixtures.GamedayId,
          phaseId: fixtures.PhaseId,
          language: config.language,

          // guid: getUserProfile(this.props.loginData).guid,
          // matchdayId: fixtures.Matchday,
          // phaseId: fixtures.phId,
        },
        () => {
          //set in team data
          let selectedTeam = this.props.Gamedays.selectedTeam;
          let teamDataSkeleton = makeManageTeamSkeleton(
            selectedTeam,
            this.props.PlayerListData.rawPlayerList,
            this.props.CompositionData.data
          );
          //set the team in teamData
          this.props.TeamData.setTeamData(teamDataSkeleton.teamData);

          //check mds value and set liveteamdata
          if (getFixturesMode == config.modes.live) {
            this.props.TeamData.setLiveTeamData(teamDataSkeleton.teamData);
          }
          //end
          hideLoader();
          this.props.setLoader(false);
          this.props.FixturesData.setScreenMode(
            config.screenMode["view-manage-team"]
          );
          this.props.BoosterCardData.setTempLimitlessBooster(false);
          this.props.history.push(config.BASE_DOMAIN_LANG + "my-team");
        }
      );
    }
  };

  renderSwiper = (fixturesStrip) => {
    let slides = null;
    let self = this;
    let initialSlideDesktop =
      +self.props.FixturesData.currMatchDay.Matchday - 1;
    let trans = self.props.TransData.data;
    let slideTo = false;
    if (self.currMatchDay != self.props.FixturesData.currMatchDay.Matchday) {
      slideTo = true;
      self.currMatchDay = self.props.FixturesData.currMatchDay.Matchday;
    }
    let overallGamedayPoints = 0;

    let isUnderlined = false;

    let isCenteredSlide = false;
    // if (initialSlideDesktop > 1 && initialSlideDesktop < self.props.FixturesData.data.length) {
    //     isCenteredSlide = true;
    // }
    if (self.props.FixturesData.data.length == 1) {
      isCenteredSlide = true;
    }

    const params = {
      initialSlide:
        Math.sign(+self.props.FixturesData.currMatchDay.Matchday - 2) == -1
          ? 0
          : +self.props.FixturesData.currMatchDay.Matchday - 2,
      slidesPerView: 3,
      centeredSlides: true,
      // slidesPerView: 5,
      paginationClickable: true,
      // freeMode: true,
      // slideToClickedSlide: true,
      observer: true,
      noSwiping: true,
      // centeredSlides: isCenteredSlide,
      // centeredSlidesBounds: true,
      grabCursor: true,
      // freeModeSticky: true
    };
    if (fixturesStrip.length) {
      slides = (
        <Swiper
          {...params}
          ref={(node) => {
            if (node) self.swiper = node.swiper;
            if (slideTo)
              self.swiper.slideTo(
                +self.props.FixturesData.currMatchDay.GamedayId - 1,
                500,
                () => {}
              );
          }}
        >
          {fixturesStrip.map((element, index) => {
            let isAnyMatchLive = false;
            if (
              element.playedGames &&
              element.playedGames.mds == 1 &&
              self.props.liveScoring &&
              self.props.liveScoring.scores
            ) {
              let liveMatchIds = Object.keys(self.props.liveScoring.scores);
              let liveMatches = Object.values(self.props.liveScoring.scores);
              let allMatchesPost = liveMatches.every(
                (item) => item.status == config.liveScoringStates.post
              );
              let matchInFixture = element.match.find((m) => {
                return m.mId == liveMatchIds[0];
              });
              let GDMatchesCount =
                element.match.filter((m) => {
                  return matchInFixture && m.gdId == matchInFixture.gdId;
                }).length || 0;
              if (!(GDMatchesCount == liveMatches.length && allMatchesPost)) {
                isAnyMatchLive = true;
              }
            }

            let swiperClass = makeClasses({
              "swiper-slide": true,
              "si-disabled": !element.playedGames,
              "si-live": isAnyMatchLive ? true : false,
            });
            let ptsText = null;
            let statusTitle = getTeamDeadlineObj(
              trans,
              config.WebConfig.OffSet,
              element.match[0].Deadline
            ).displayDate;
            if (element.match[0].IsTbc == "1") {
              statusTitle = getTrans(trans, "TBC", "TBC");
            }
            if (element.playedGames) {
              let gamedayPoints = +self.props.Gamedays.data.find(
                (g) => g.GamedayId === element.GamedayId
              )?.Points;
              if (element.playedGames.mds == 0) {
                isUnderlined = true;
                statusTitle = getTrans(trans, "manage", "Manage");
              } else if (element.playedGames.mds == 1) {
                //for status ft
                overallGamedayPoints = element.playedGames.pts || 0;
                if (self.props.LiveScoringData?.scoring?.length) {
                  let boosters = getBoostersObject(
                    self.props.CompositionData.boostersList,
                    self.props.Gamedays.selectedTeam.Boosters
                  );
                  let boosterApplied = getAppliedBooster(
                    boosters,
                    +element.GamedayId
                  );
                  overallGamedayPoints =
                    getOverallGamedayPoints(
                      self.props.LiveScoringData.scoring,
                      self.props.TeamData.data,
                      boosterApplied,
                      +element.GamedayId
                    ) +
                    +self.props.Gamedays.data.find(
                      (g) => g.GamedayId === element.GamedayId
                    )?.Points;
                } else {
                  overallGamedayPoints = +self.props.Gamedays.data.find(
                    (g) => g.GamedayId === element.GamedayId
                  )?.Points;
                }
                isAnyMatchLive = true;
                ptsText =
                  config.language === config.lang.English
                    ? overallGamedayPoints +
                      " " +
                      (overallGamedayPoints === 1
                        ? getTrans(trans, "pt", "Pt")
                        : getTrans(trans, "pts", "pts"))
                    : (overallGamedayPoints === 1
                        ? getTrans(trans, "pt", "Pt")
                        : getTrans(trans, "pts", "pts")) +
                      " " +
                      overallGamedayPoints;
                statusTitle = getTrans(trans, "live", "LIVE");
                statusTitle = getTrans(trans, "live", "LIVE");
              } else if (element.playedGames.mds == 2) {
                isUnderlined = true;
                overallGamedayPoints = gamedayPoints || 0;
                statusTitle = getTrans(trans, "substitute", "Substitute");
                ptsText =
                  config.language === config.lang.English
                    ? overallGamedayPoints +
                      " " +
                      (overallGamedayPoints === 1
                        ? getTrans(trans, "pt", "Pt")
                        : getTrans(trans, "pts", "pts"))
                    : (overallGamedayPoints === 1
                        ? getTrans(trans, "pt", "Pt")
                        : getTrans(trans, "pts", "pts")) +
                      " " +
                      overallGamedayPoints;
              } else if (element.playedGames.mds == 3) {
                isUnderlined = true;
                statusTitle = getTrans(trans, "view_points", "View Points");
                ptsText =
                  config.language === config.lang.English
                    ? (gamedayPoints ? gamedayPoints : 0) +
                      " " +
                      (gamedayPoints === 1
                        ? getTrans(trans, "pt", "Pt")
                        : getTrans(trans, "pts", "pts"))
                    : (gamedayPoints === 1
                        ? getTrans(trans, "pt", "Pt")
                        : getTrans(trans, "pts", "pts")) +
                      " " +
                      (gamedayPoints ? gamedayPoints : 0);
              }
            } else {
              isUnderlined = false;
            }
            return (
              <div
                key={index}
                className={swiperClass}
                onClick={() => {
                  self.getTeam(element);
                }}
              >
                <div
                  className={
                    "si-cmo__matches-box " + (isAnyMatchLive ? "si-live" : "")
                  }
                >
                  <div className="si-cmo__matches-title">
                    <span>
                      {getTrans(trans, "WD", "W")}
                      <em>{element.Gameday}</em>
                      {config.language == config.lang.English
                        ? ptsText
                          ? "- " + ptsText
                          : null
                        : ptsText
                        ? ptsText + " -"
                        : null}
                    </span>
                  </div>
                  <div
                    className={
                      "si-cmo__matches-cta " +
                      (isUnderlined ? "si-btm-border" : "")
                    }
                  >
                    <span>{statusTitle}</span>
                  </div>
                </div>
              </div>
            );
          })}
        </Swiper>
      );
    }

    return slides;
  };

  goNext() {
    let self = this;

    let currentMd = +self.props.FixturesData.currMatchDay.Matchday;
    let incrementedMdId = currentMd + 1;
    let incrementedMd =
      self.props.FixturesData.fixturesStrip[incrementedMdId - 1];
    if (!isEmpty(incrementedMd)) {
      let doubleIncMdId = currentMd + 2;
      let doubleIncMd =
        self.props.FixturesData.fixturesStrip[doubleIncMdId - 1];
      if (!isEmpty(doubleIncMd) && !isEmpty(doubleIncMd.playedGames)) {
        self.setState({
          disableForward: false,
          disableBack: false,
        });
      } else {
        self.setState({
          disableForward: true,
          disableBack: false,
        });
      }
      //make team call
      if (incrementedMd.playedGames) {
        self.getTeam(incrementedMd);
      } else {
        self.setState({
          disableForward: true,
          disableBack: false,
        });
      }
    } else {
      self.setState({
        disableForward: true,
        disableBack: false,
      });
    }
  }

  goPrev() {
    let self = this;

    let currentMd = +self.props.FixturesData.currMatchDay.Matchday;
    let decrementedMdId = currentMd - 1;
    let decrementedMd =
      self.props.FixturesData.fixturesStrip[decrementedMdId - 1];
    if (!isEmpty(decrementedMd)) {
      let doubleDecMdId = currentMd - 2;
      let doubleDecMd =
        self.props.FixturesData.fixturesStrip[doubleDecMdId - 1];
      if (!isEmpty(doubleDecMd) && !isEmpty(doubleDecMd.playedGames)) {
        self.setState({
          disableForward: false,
          disableBack: false,
        });
      } else {
        self.setState({
          disableForward: false,
          disableBack: true,
        });
      }
      //make team call
      //make team call
      if (decrementedMd.playedGames) {
        self.getTeam(decrementedMd);
      } else {
        self.setState({
          disableForward: false,
          disableBack: true,
        });
      }
      // self.getTeam(decrementedMd);
    } else {
      self.setState({
        disableForward: false,
        disableBack: true,
      });
    }
  }

  render() {
    let self = this;
    return (
      <React.Fragment>
        {self.renderSwiper(self.props.FixturesData.fixturesStrip)}

        {self.props.FixturesData.fixturesStrip.length > 1 ? (
          <React.Fragment>
            <div
              className={
                self.state.disableForward
                  ? "swiper-button-next si-disabled"
                  : "swiper-button-next"
              }
              onClick={() => {
                self.goNext();
              }}
            ></div>
            <div
              className={
                self.state.disableBack
                  ? "swiper-button-prev si-disabled"
                  : "swiper-button-prev"
              }
              onClick={() => {
                self.goPrev();
              }}
            ></div>
          </React.Fragment>
        ) : (
          <Fragment />
        )}
      </React.Fragment>
    );
  }
}

export default Consume(FixturesStrip, [
  WebConfigDataContext,
  ConstraintsContext,
  TransContext,
  FixturesContext,
  CompositionContext,
  TeamDataContext,
  PlayerListContext,
  PlayerRecommendationContext,
  GamedaysContext,
  LoginContext,
  LiveScoringContext,
  BoosterCardContext,
]);
